
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Sponsors',

    metaInfo: { title: 'Sponsors' },

    extends: View,

    mixins: [
      LoadSections([
        'sponsors',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'sponsors',
      },
    },
  }
</script>
